<template>
  <div class="" v-if="valueModel">
    <div v-if="props.label" class="text-muted text-start">{{ props.label }} {{ props.required ? '*' : '' }}</div>
    <div class="btn-group d-flex flex-wrap" role="group" :aria-label="props.label" :class="{'is-invalid': errorMessage}">
      <template v-for="(option, index) in props.options" :key="option.value">
        <input v-model="valueModel.value" :value="option.value" type="radio" class="btn-check" :name="`btnradio-${$.uid}`" :id="`btnradio-${index}-${$.uid}`" autocomplete="off">
        <label class="btn btn-outline-primary" :for="`btnradio-${index}-${$.uid}`">{{ option.label }}</label>
      </template>
    </div>
    <div class="invalid-feedback">
      {{ errorMessage }}
    </div>
  </div>
</template>

<style>
.btn-group.is-invalid label {
  border-color: #dc3545;
  color: #dc3545;
}
</style>
<script setup lang="ts">
import { computed } from 'vue';
import { useField } from 'vee-validate';

const model = defineModel<string|number>({required: false});

const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  label?: string;
  required: boolean;
  options: Array<{ value: string|number; label: string, selected?: boolean }>;
}>(), {
  required: false,
});

const { value, errorMessage } = props.valueKey !== undefined ? useField<string>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey) return value;
  else if(model.value !== undefined) return model;
  else return undefined;
})
</script>
